import * as React from "react";
import {
  DEVELOPMENT_NEW_URL,
  STAGING_NEW_URL,
  PRODUCTION_NEW_URL,
  SHOW_LEGACY_NEW_SWITCH,
  IS_DEPLOYMENT_ENV_TEST,
  IS_DEPLOYMENT_ENV_STAGING,
  IS_DEPLOYMENT_ENV_PROD,
  CONSOLE_URL,
} from "../../../envVariables";
import { Button } from "antd";
import { CrownOutlined } from "@ant-design/icons";

function getTargetHost() {
  if (IS_DEPLOYMENT_ENV_TEST) {
    return DEVELOPMENT_NEW_URL;
  }
  if (IS_DEPLOYMENT_ENV_STAGING) {
    return STAGING_NEW_URL;
  }
  if (IS_DEPLOYMENT_ENV_PROD) {
    return PRODUCTION_NEW_URL;
  }
  return "";
}

export function getTargetUrl() {
  const currentUrl = window.location.href;
  const currentHost = CONSOLE_URL!;
  const targetHost = getTargetHost();

  let targetUrl = currentUrl.replace(currentHost, targetHost);
  if (targetUrl.includes(`/-create`)) {
    targetUrl = targetUrl.split(`/-create`)[0];
  }

  if (targetUrl.includes(`/billing`)) {
    targetUrl = targetUrl.split(`/billing`)[0] + `/home/account`;
  }

  return targetUrl;
}

export const ConsoleSwitch: React.FC = () => {
  if (!SHOW_LEGACY_NEW_SWITCH) {
    return null;
  }

  return (
    <Button
      type="primary"
      icon={<CrownOutlined />}
      iconPosition="start"
      onClick={() => {
        window.location.href = getTargetUrl();
        localStorage.setItem("TARGET_MODE", "new");
      }}
    >
      <a
        href={getTargetUrl()}
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        Switch to New Console
      </a>
    </Button>
  );
};
